import appConfig from '../../config';
import {pathResolver} from './basePathHelper';

export const pathTermsOfUse = pathResolver('resources/termsOfUse/');
export const pathTermsAndConditions = pathResolver('resources/termsAndConditions/');
export const pathPrivacyPolicy = pathResolver('resources/privacyPolicy/');
export const pathDocumentExamples = pathResolver('resources/documents/examples/');
export const pathDocumentTemplates = pathResolver('resources/documents/templates/');
export const pathHelpContentFile = pathResolver('resources/helpContent/');

export function getTermsOfUsePath(locale) {
  let termsOfUseFile = 'Term_of_Use_OFA_EN_20241001.pdf';
  if (locale === 'fr') {
    termsOfUseFile = 'Term_of_Use_OFA_FR_20241001.pdf';
  }

  return pathTermsOfUse + termsOfUseFile;
}

export function getTermsAndConditionsPath(locale) {
  let termsAndConditionsFile = 'Terms_conditions_OFA_EN_20241001.pdf';
  if (locale === 'fr') {
    termsAndConditionsFile = 'Terms_conditions_OFA_FR_20241001.pdf';
  }

  return pathTermsAndConditions + termsAndConditionsFile;
}

export function getPrivacyPolicyPath(locale) {
  let privacyPolicyFile = 'Privacy_Notice_OFA_EN_20241001.pdf';
  if (locale === 'fr') {
    privacyPolicyFile = 'Privacy_Notice_OFA_FR_20241001.pdf';
  }

  return pathPrivacyPolicy + privacyPolicyFile;
}

export function getNewsUrlFromLocale(locale) {
  if (locale === 'fr') {
    return 'https://www2.attestationlegale.fr/actualites';
  }

  return null;
}

// Keeping in case it changes again later
export function getVitrineUrl(_organisationId) {
  const url = appConfig.ssoVitrineURL;
  // if (organisationId) {
  //   url = `${url}?ofaOrganisationId=${organisationId}`;
  // }
  return `${url}/global-dashboard`;
}

// Keeping in case it changes again later
export function getBdrUrl(_organisationId) {
  return appConfig.ssoBdrURL;
}

export function getDiscoverVitrineUrlFromLocale(locale) {
  switch (locale) {
    case 'fr': return 'https://adherent.attestationlegale.fr/liste-references-chantier';
    default: return 'https://adherent.attestationlegale.fr/construction-references-list';
  }
}

export function getOrigin() {
  if (appConfig.isMicrofront) {
    return `${window.location.origin}/${window.location.pathname.split('/').filter(Boolean)[0]}`;
  }

  return window.location.origin;
}
